<template>
  <!-- 信息动态 -->
  <div class="warrper">
    <div class="header">
      <img
        style="width: 100%; height: 100%"
        src="../assets/cp/xxdt.png"
        alt=""
      />
    </div>
    <el-backtop></el-backtop>
    <div class="gsjj">
      <div
        style="
          margin-top: 20px;
          margin-left: 20%;
          color: #d3d3d3;
          cursor: pointer;
        "
      >
        <span @click="tiaozhuan()">首页></span
        ><span style="color: black">信息动态</span>
      </div>
      <div class="bt">
        <div class="search" style="margin-top: 15px">
          <el-input
            placeholder="请输入新闻名称"
            v-model="input3"
            class="input-with-select"
          >
            <el-button slot="append" @click="serchXW()"
              ><img src="../assets/xw/xi-magnifier.png"
            /></el-button>
          </el-input>
        </div>
      </div>
      <div class="xwbk wow fadeInUp" data-wow-duration=".5s">
        <div class="newleftFirst">
          <el-menu
            style="text-align: center"
            router
            :default-active="activeMenu"
            class="el-menu-demo"
            mode="horizontal"
          >
            <el-menu-item index="/hyxw1">
              <span slot="title" style="font-size: 20px">行业新闻</span>
            </el-menu-item>
            <el-menu-item index="/zcfg1">
              <span slot="title" style="font-size: 20px">政策法规</span>
            </el-menu-item>
            <el-menu-item index="/xmdt1">
              <span slot="title" style="font-size: 20px">项目动态</span>
            </el-menu-item>
            <el-menu-item index="/tzgg1">
              <span slot="title" style="font-size: 20px">通知公告</span>
            </el-menu-item>
          </el-menu>
          <div>
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </div>
        </div>
        <div class="newrightFirst">
          <h3 style="font-size: 20px">
            热门推荐<img
              style="margin-left: 10px"
              src="../assets/xw/火 (3) 拷贝.png"
            />
          </h3>
          <p style="border: 1px solid #dedede; margin-top: -8px"></p>
          <ul v-for="item in ggData" :key="item.id">
            <li @click="ckxxxx(item.id)">
              {{ item.name }}
            </li>
            <el-divider></el-divider>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WOW from "wowjs";
import { selectbrief, selvypublics } from "@/api/patient.js";
export default {
  components: {},
  name: "Home",
  data() {
    return {
      ggData: [],
      // dentity: "行业新闻",
      page: 1,
      rows: 100000,
      rows1: 3,
      datatotal: 0,
      input3: "",
      search: false,
      show1: false,
      searchData: [],
    };
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.getSelvypublics();
    }, 500);
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },
  methods: {
    // handleCurrentChange(val) {
    //   this.page = val;
    //   this.serchXW();
    // },
    //搜索新伟
    serchXW() {
      this.$store.commit("scrxi", this.input3);
      const routeUrl = this.$router.resolve({
        path: "/search",
      });
      window.open(routeUrl.href, "_blank");
      this.input3 = "";
      // let data = new FormData();
      // data.append("page", this.page);
      // data.append("rows", this.rows1);
      // data.append("xueyuan", "倒");
      // data.append("school", this.input3);
      // // data.append("dentity", this.dentity);
      // selvypublics(data).then((res) => {
      //   this.searchData = res.rows
      //   this.datatotal = res.total;
      //   this.search = true
      // });
    },
    //查看详细信息
    ckxxxx1(item) {
      this.show1 = true;
      this.$router.push("/newsItem1/" + `${item}`);
    },
    ckxxxx(item) {
      this.$router.push("/newsItem1/" + `${item}`);
    },
    tiaozhuan() {
      this.$router.push("/");
    },
    //获取新闻
    async getSelvypublics() {
      let data = new FormData();
      data.append("page", this.page);
      data.append("rows", this.rows);
      data.append("xueyuan", "倒");
      // data.append("dentity", this.dentity);
      selvypublics(data).then((res) => {
        this.ggData = res.rows;
        for (var j = 0; j < this.ggData.length - 1; j++) {
          //arr.length-1-j  -j即每次比较，都可以减少 比较次数 的次数; -1即每次最后一个数（最大值）都无需比较（不能再继续向下比较）
          for (var i = 0; i > this.ggData.length - 1 - j; i++) {
            if (this.ggData[i].countpublic > this.ggData[i + 1].countpublic) {
              var tmp = this.ggData[i];
              this.ggData[i] = this.ggData[i + 1];
              this.ggData[i + 1] = tmp;
            }
          }
        }
        this.ggData = this.ggData.slice(0, 6);
        this.datatotal = res.total;
      });
    },
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  watch: {},
};
</script>
<style scoped>
>>> .el-input__inner {
  height: 50px;
}

.el-menu {
  width: 831px;
}

.el-menu-item {
  /* height: 36px; */
  width: 200px;
  margin-bottom: 30px;
}

.el-menu-item {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  background: #ffffff;
}
</style>
<style lang="scss" scoped>
.warrper {
  width: 100%;

  .header {
    width: 100%;
    height: 407px;
    // background-image: url(../assets/xw/cd2522fe6c8b4a866dc3f254fe557baf1.png);
    // background-size: 100%, 100%;
    // background-size: cover;
    // background-repeat: no-repeat;
  }

  .gsjj {
    width: 100%;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard {
        width: 200px;
        height: 200px;
        margin: 50px;
        border-radius: 10px;
        // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);
        text-align: center;

        h3 {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #676767;
        }
      }
    }

    .xwbk {
      width: 60%;
      padding-top: 70px;
      margin: auto;
      display: flex;

      .rmtj1 {
        width: 100%;
        // display: flex;

        .newLeftFirst {
          width: 800px;
          margin: auto;
          // height: 163px;
          background: #ffffff;
          border-bottom: 1px solid #dedede;

          h2 {
            height: 19px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          p {
            height: 17px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 25px;
          }

          .first {
            padding-top: 25px;
            display: flex;
            justify-content: space-between;
          }

          .brows {
            display: flex;
            align-items: center;

            p {
              margin-left: 5px;
              display: flex;
              align-items: center;
            }
          }
        }

        .newLeftFirst:hover {
          width: 800px;
          // height: 163px;
          cursor: pointer;
          background: #f6f6f6;
          border-bottom: 1px solid #dedede;

          h2 {
            height: 19px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          h2:hover {
            height: 19px;
            font-size: 18px;
            cursor: pointer;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #409eff;
          }

          p {
            height: 17px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 25px;
          }

          .first {
            padding-top: 25px;
            display: flex;
            justify-content: space-between;
          }

          .brows {
            display: flex;
            align-items: center;

            p {
              margin-left: 5px;
              display: flex;
              align-items: center;
            }
          }
        }
      }

      .newrightFirst {
        width: 332px;
        margin-left: 30px;

        h3 {
          margin-left: 20px;
        }

        ul {
          li {
            width: 262px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }

          li:hover {
            // width: 262px;
            cursor: pointer;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #409eff;
            line-height: 24px;
          }
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      .search {
        width: 803px;
        height: 50px;
        margin: auto;
        background: #ffffff;
        box-shadow: 0px 3px 11px 0px rgba(0, 0, 0, 0.13);
        border-radius: 5px 5px 5px 5px;
      }

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>
